import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import { Application } from '@/types/application';
import { SearchBlocksItem } from '@/types/search';
import { VariableScope } from '@/types/variable';
import CircleIcon from '@mui/icons-material/Circle';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText, Tooltip } from '@mui/material';
import { FC, useState } from 'react';
import VariableListItemEdit from './VariableListItemEdit';

type VariableListItemProps = {
  application: Application;
  readOnly?: boolean;
  variableIsUsed: inUse;
  onVariableSearch: (searchValue: SearchBlocksItem) => void;
  onSave?: (name: string, type: string) => void;
  onDelete?: () => void;
  variableName?: string;
  variableType?: string;
  scope: VariableScope;
};

const VariableListItem: FC<VariableListItemProps> = (props) => {
  const [openEdit, setOpenEdit] = useState(false);

  const searchItem: SearchBlocksItem = {
    searchQuery: props.variableName ?? '',
    searchType: 'Variable',
    scope: props.scope
  };

  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 0 }}>
      {openEdit ? (
        <VariableListItemEdit
          variableName={props.variableName}
          variableType={props.variableType}
          scope={props.scope}
          onClose={() => setOpenEdit(false)}
          onSave={(variableName: string, variableType: string) => {
            props.onSave && props.onSave(variableName, variableType);
          }}
        />
      ) : (
        <>
          <Tooltip
            onClick={() => props.variableIsUsed && props.onVariableSearch(searchItem)}
            title={
              props.variableIsUsed
                ? props.variableIsUsed === 'green'
                  ? 'Variable is in use. Click to find all references.'
                  : 'Variable is in use elsewhere. Click to find all references.'
                : ''
            }
          >
            <CircleIcon
              sx={{
                color: props.variableIsUsed ?? 'transparent',
                cursor: props.variableIsUsed ? 'pointer' : 'unset',
                pr: '5px'
              }}
            />
          </Tooltip>
          <ListItemText
            primary={props.variableName}
            sx={{
              ...(props.readOnly && {
                fontStyle: 'italic',
                opacity: 0.5
              })
            }}
          />
          <code>{props.variableType}</code>
          <Box sx={{ visibility: props.readOnly ? 'hidden' : 'visible' }}>
            <IconButton tooltip='Edit' onClick={() => !props.readOnly && setOpenEdit(true)}>
              <EditIcon />
            </IconButton>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{props.variableName}</code>?
                </>
              }
              onConfirm={() => props.onDelete && !props.readOnly && props.onDelete()}
              skipConfirm={!props.variableName}
              icon={<ClearIcon />}
            />
          </Box>
        </>
      )}
    </ListItem>
  );
};

export default VariableListItem;
